import lineIcon from '@/public/images/line.svg';
import hatenaIcon from '@/public/images/hatena.svg';
import facebookIcon from '@/public/images/facebook.svg';
import xIcon from '@/public/images/x.svg';
import Image from 'next/legacy/image';

const toQueryParam = (o: { [k: string]: string }) => {
  const p = new URLSearchParams();
  Object.entries(o).forEach(([k, v]) => p.set(k, v));
  return p;
};

const toUrl = (url: string, params: { [k: string]: string }) =>
  `${url}?${toQueryParam(params)}`;

const A: React.FC<
  {
    base: string;
    params: { [k: string]: string };
  } & React.ComponentPropsWithoutRef<'a'>
> = ({ base, params, ...rest }) => (
  <a
    href={toUrl(base, params)}
    target='_blank'
    rel='noopener noreferrer'
    {...rest}
  />
);

export const PostHeadShareButtons: React.FC<{
  post: { title?: string | null; slug?: string | null };
  path: string;
}> = ({ post, path }) => {
  if (!post.title) {
    return null;
  }

  const url = `https://${
    process.env.NEXT_PUBLIC_FRONT_SERVICE_HOST || process.env.FRONT_SERVICE_HOST
  }${path}`;

  return (
    <div className='flex gap-1'>
      <A
        base='https://twitter.com/share'
        params={{ url, text: post.title }}
        aria-label='Twitterで共有'
        className='flex-shrink-0'
      >
        <Image src={xIcon} width={30} height={30} alt='Xのアイコン' />
      </A>
      <A
        base='https://www.facebook.com/sharer/sharer.php'
        params={{ u: url, quote: post.title }}
        aria-label='Facebookで共有'
      >
        <Image
          src={facebookIcon}
          width={30}
          height={30}
          alt='Facebookのアイコン'
        />
      </A>
      <A
        base='http://b.hatena.ne.jp/add'
        params={{ mode: 'confirm', url, title: post.title }}
        aria-label='はてなブックマークで共有'
      >
        <Image
          src={hatenaIcon}
          width={30}
          height={30}
          alt='はてなブックマークのアイコン'
        />
      </A>
      <A
        base='https://social-plugins.line.me/lineit/share'
        params={{ url, text: post.title }}
        aria-label='Lineで共有'
      >
        <Image src={lineIcon} width={30} height={30} alt='Lineのアイコン' />
      </A>
    </div>
  );
};
